import { ElementRef, HostListener } from '@angular/core';
import { Directive } from '@angular/core';
import { NgControl } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';

@Directive({
  selector: '[appSelectKeyboard]'
})
export class SelectKeyboardDirective {

  constructor(private ngControl : NgSelectComponent) { }

  @HostListener('change', ['$event'])
  onMouseEnter(event: any) {  
   // //console.log(this.ngControl) 
    this.ngControl.blur()
  }
}
